import { Box } from "@chakra-ui/react"

export const EmptyCard = () => {
    return (
        <Box width="100%" />
    )
}
